import React from 'react';
import NoReplenListData from 'src/pages/reportUsage/common/NoData';
import RowHeaderTemplateMobile from './RowHeaderTemplateMobile';
import RowTemplateMobile from './RowTemplateMobile';
import { useTranslation } from 'react-i18next';

const ReplenListViewMobile = ({
    gridData,
    headerCheckboxClickHandler,
    checkboxClickHandler,
    quantityInputChangeHandler,
}) => {
    const { t } = useTranslation();
    return (
        <>
            <RowHeaderTemplateMobile
                gridData={gridData}
                headerCheckboxClickHandler={headerCheckboxClickHandler}
            />
            {gridData && gridData.filter((x) => !x.accountOwned)?.length > 0 ? (
                gridData.map((item, idx) => {
                    return !item.accountOwned ? (
                        <RowTemplateMobile
                            key={item.cfn}
                            item={item}
                            idx={idx}
                            checkboxClickHandler={checkboxClickHandler}
                            quantityInputChangeHandler={
                                quantityInputChangeHandler
                            }
                        />
                    ) : null;
                })
            ) : (
                <NoReplenListData
                    content={t('replen.noItemToBeReplenished')}
                    padding="24px 14px"
                />
            )}
        </>
    );
};

export default ReplenListViewMobile;
